import Input from "decorator-form/dist/decorators/input/Input";
import { Entity } from "typegraph";
import Field from "typegraph/dist/decorators/field/Field";
import InputType from "common/form/InputType";
import DropdownSelect from "../../../common/form/widgets/common/DropdownSelect";
import Topic from "./Topic";
import User from "./User";

const DigestOptions = DropdownSelect.registerWithOptions([
	{
		value: "none",
		label: "None"
	},
	{
		value: "immediate",
		label: "Immediately"
	},
	{
		value: "daily",
		label: "Daily"
	},
	{
		value: "weekly",
		label: "Weekly"
	}
]);

@Entity({one: "userSubscription", many: "userSubscriptionsUser", create: "userSubscriptionCreate", update: "userSubscriptionUpdate", delete: "userSubscriptionDelete"})
export class UserSubscription {

	@Field()
	id: number;

	@Field()
	@Input({type: InputType.CHECKBOX, title: "Instant Notification"})
	instant: boolean = true;

	user: number;

	targetUser: number;

	// temporary untill the graphql api supports the same type for both mutations and queries
	@Field({aliasFor: "targetUser", entity: User})
	targetUserEntity: User;

	@Field()
	@Input({type: InputType.CHECKBOX, title: "Recieve Emails"})
	emailNotification: boolean = true;

	@Field()
	@Input({type: DigestOptions, title: "Send a notification summary email", required: true})
	digest: String;
}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/UserSubscription.ts